import { DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton, UITextInput } from "components/ui";
import React from "react";


/**
 * @function EmailAddressWidget
 * @return {React.Component}
 * @exported true
 * @description The main widget used in the ACTContactInfoPage. 
 */
export default function EmailAddressWidget(props) {
  const navigate = useRoute();

  return (
    <WidgetContainer className="email-address-widget">
      <WidgetView text="Email Address">
        <FormContainer className="small-form-width">
          <FormRowView className="new-email-address-row-view" text="New Email Address">
            <UITextInput />
          </FormRowView>
          <FormRowView className="confirm-email-address-row-view" text="Confirm Email Address">
            <UITextInput />
          </FormRowView>
          <FormButtonRow>
            <SecondaryButton text="Cancel" onClick={() => { navigate("/profile") }} />
            <DisabledPrompt>
              <PrimaryButton text="Update" />
            </DisabledPrompt>
          </FormButtonRow>
        </FormContainer>
      </WidgetView>
    </WidgetContainer>
  )
}
